// ForeignCompanyRegistration.jsx
import React from "react";

export default function ForeignCompanyRegistration() {
  const handleWhatsAppClick = () => {
    const phoneNumber = "919217468906"; // without +
    const message =
      "Hello! I would like to get a consultation for Foreign Company Registration in India.";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank");
  };

  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Foreign Company
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Foreign Company Registration in India
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists foreign companies in establishing
            operations in India while complying with Indian corporate, tax, and
            regulatory requirements, providing a legally recognized presence
            for overseas entities.
          </p>
          <p className="text-gray-700">
            From planning the route of entry and documentation to handling
            filings and post‑registration formalities, the team supports foreign
            businesses through each stage of setting up in the Indian market.
          </p>
        </div>

        {/* Right: Square Image */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/5668768/pexels-photo-5668768.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Foreign company leadership discussing India registration"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Foreign Company Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks coordinates with the foreign company and
              Indian representatives to compile and present all documents needed
              for registration and compliance.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>
                  Incorporation documents of the foreign company, including
                  Certificate of Incorporation and charter documents.
                </li>
                <li>
                  Board resolution authorising establishment in India and
                  appointing an authorised representative.
                </li>
                <li>
                  Identity and address proof of directors and authorised
                  representative.
                </li>
                <li>
                  Proof of registered or principal place of business address in
                  India.
                </li>
                <li>
                  Digital Signature Certificates (DSC) and identification
                  numbers for signatories, as applicable.
                </li>
                <li>
                  Any approvals or declarations required under sectoral or
                  foreign‑investment regulations, where applicable.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm provides foreign companies with structured guidance and
              hands‑on support, helping them navigate Indian procedures with
              clarity and confidence.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Regulatory Clarity
                </h3>
                <p className="text-gray-700 text-sm">
                  Clear explanation of applicable Indian laws, registration
                  routes, and ongoing obligations for foreign entities.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Cross‑Border Incorporation Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Experience in handling foreign company entry, including
                  documentation standards and coordination between jurisdictions.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Trusted Professional Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  End‑to‑end assistance for filings, responses to queries, and
                  post‑registration compliances.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <button
                type="button"
                onClick={handleWhatsAppClick}
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </button>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
